import { Directive, TemplateRef } from '@angular/core';


@Directive({ selector: '[pageTab1]', standalone: true })
export class PageTab1Directive {
	constructor(public tpl: TemplateRef<any>) { }
}

@Directive({ selector: '[pageTab2]', standalone: true })
export class PageTab2Directive {
	constructor(public tpl: TemplateRef<any>) { }
}

@Directive({ selector: '[pageTab3]', standalone: true })
export class PageTab3Directive {
	constructor(public tpl: TemplateRef<any>) { }
}

@Directive({ selector: '[pageTab4]', standalone: true })
export class PageTab4Directive {
	constructor(public tpl: TemplateRef<any>) { }
}

@Directive({ selector: '[pageTab5]', standalone: true })
export class PageTab5Directive {
	constructor(public tpl: TemplateRef<any>) { }
}

@Directive({ selector: '[pageTab6]', standalone: true })
export class PageTab6Directive {
	constructor(public tpl: TemplateRef<any>) { }
}

@Directive({ selector: '[pageTab7]' })
export class PageTab7Directive {
	constructor(public tpl: TemplateRef<any>) { }
}